// src/components/email/EmailTemplate.jsx
import { useState } from "react";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const EmailTemplate = () => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const saveTemplate = async () => {
    const res = await fetch("/api/emails/template", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ subject, body }),
    });
    if (res.ok) toast.success("Template saved");
    else toast.error("Save failed");
  };

  return (
    <div className="space-y-3 mt-6">
      <h2 className="text-xl font-semibold">Create Template</h2>
      <Textarea value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Subject" />
      <Textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder="Body content..." rows={6} />
      <Button onClick={saveTemplate}>Save Template</Button>
    </div>
  );
};

export default EmailTemplate;
